import { Trans } from '@lingui/react/macro';

import { useCRMAudienceReportMetadata } from '@/api/audience';
import { ReportName } from '@/components/ReportName';
import { Text } from '@/components/typography';

type Props = {
  url?: string;
};

const AudienceDetailEditSalesforce = ({ url }: Props) => {
  const {
    reportMetadata,
    isLoading: isReportLoading,
    error: reportError,
  } = useCRMAudienceReportMetadata(url);

  return (
    <div className="flex flex-col gap-4">
      <div>
        <Text variant="body1">
          <Trans>
            <strong>Note: </strong>
            Your Salesforce Accounts report must include the standard Account object field "
            <strong>Website</strong>" as a column, and must not contain groupings.
          </Trans>
        </Text>
      </div>
      <Text variant="label">
        <Trans>Salesforce Report Link</Trans>
      </Text>
      <Text variant="body1" color="grey">
        {url}
      </Text>
      {
        <ReportName
          reportName={reportMetadata?.name}
          isLoading={isReportLoading}
          error={reportError}
        />
      }
    </div>
  );
};

export default AudienceDetailEditSalesforce;
